export default __webpack_public_path__ + "static/top-mobile-app-usa-banner-a334eb439c84594fe55ff9e6354d7471.jpg";